import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';

import flatpickr from 'flatpickr';

import.meta.glob([
    '../img/front/**',
]);

import './common/modal'
import './common/tooltip'
import './front/badge-scanner'
import './front/program'
import './front/carousels'
import './front/detail-modal'

window.Alpine = Alpine;

Livewire.start();

/** Touchscreen */
if ('ontouchstart' in window || navigator.maxTouchPoints) {
    document.body.classList.add('is_touchscreen');
}

/**
 * Datepickers
 * Doc. : https://flatpickr.js.org/options/
 */

var current_lang = localStorage && localStorage.getItem('lang').substring(0, 2);

flatpickr('.time-picker', {
    enableTime: true,
    noCalendar: true,
    dateFormat: current_lang === 'fr' ? 'H:i' : 'h:i K',
    time_24hr: current_lang === 'fr'
});

flatpickr('.date-picker-range', {
    mode: 'range',
    wrap: true,
    dateFormat: current_lang === 'fr' ? 'd-m-Y' : 'd-m-Y',
    locale: { rangeSeparator: '  —  ' }
});
